<script>
import FormElement from '@wielink-application/shared/vue/components/form/input-only/file.vue'

export default FormElement;
</script>